import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarkupMeasureRectangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.66757 11.0928C5.56427 11.8733 5.49217 12.6633 5.39621 13.4478C5.39621 13.5481 5.33987 13.8038 5.41801 13.8646C5.70397 14.087 6.02268 14.2618 6.30721 14.4921C6.58927 14.7204 6.66062 15.073 6.90323 15.3377C7.16552 15.6238 7.44639 15.8964 7.73428 16.1566C7.79705 16.2133 7.91476 16.3605 8.01291 16.3698C8.5545 16.4214 9.10589 16.3625 9.65077 16.4134C10.5498 16.4974 11.4554 16.5612 12.3571 16.6097C13.2677 16.6586 14.2573 16.9535 15.1652 16.8205C15.3491 16.7935 15.7454 16.7853 15.863 16.6024C16.0472 16.3158 16.0678 15.9572 16.2579 15.672C16.4551 15.3763 16.6585 15.059 16.9315 14.8264C17.1683 14.6247 17.517 14.5372 17.7819 14.3734L17.7919 14.3672C18.1345 14.1554 18.6053 13.8642 18.7753 13.4817C18.8599 13.2915 18.8286 13.0524 18.8286 12.8494C18.8286 12.3657 18.8252 11.8875 18.785 11.4053C18.7596 11.1009 18.657 10.658 18.4797 10.4047C18.3471 10.2152 18.0291 10.0728 17.8352 9.95889C16.8215 9.3635 16.6129 7.80588 15.393 7.55055C14.7631 7.41871 14.1152 7.42941 13.4716 7.42941C12.7112 7.42941 11.9774 7.45816 11.2208 7.52632C10.3074 7.60861 9.38828 7.80868 8.4781 7.93094C8.32121 7.95202 7.85611 7.94605 7.80454 8.14658C7.74776 8.36739 7.71073 8.62289 7.60102 8.82498C7.21702 9.53236 6.07957 9.36195 5.79113 10.1551C5.68266 10.4535 5.70868 10.7822 5.66757 11.0928Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5C21 17.8807 19.8807 19 18.5 19C17.1193 19 16 17.8807 16 16.5Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 16.5C3 15.1193 4.11929 14 5.5 14C6.88071 14 8 15.1193 8 16.5C8 17.8807 6.88071 19 5.5 19C4.11929 19 3 17.8807 3 16.5Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 7.5C3 6.11929 4.11929 5 5.5 5C6.88071 5 8 6.11929 8 7.5C8 8.88071 6.88071 10 5.5 10C4.11929 10 3 8.88071 3 7.5Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 7.5C16 6.11929 17.1193 5 18.5 5C19.8807 5 21 6.11929 21 7.5C21 8.88071 19.8807 10 18.5 10C17.1193 10 16 8.88071 16 7.5Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 16.5C16 17.8807 17.1193 19 18.5 19C19.8807 19 21 17.8807 21 16.5C21 15.1193 19.8807 14 18.5 14M16 16.5C16 15.1193 17.1193 14 18.5 14M16 16.5H8M18.5 14V10M8 16.5C8 17.8807 6.88071 19 5.5 19C4.11929 19 3 17.8807 3 16.5C3 15.1193 4.11929 14 5.5 14M8 16.5C8 15.1193 6.88071 14 5.5 14M5.5 14V10M5.5 10C4.11929 10 3 8.88071 3 7.5C3 6.11929 4.11929 5 5.5 5C6.88071 5 8 6.11929 8 7.5M5.5 10C6.88071 10 8 8.88071 8 7.5M8 7.5H16M18.5 10C17.1193 10 16 8.88071 16 7.5M18.5 10C19.8807 10 21 8.88071 21 7.5C21 6.11929 19.8807 5 18.5 5C17.1193 5 16 6.11929 16 7.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMarkupMeasureRectangle;
